/**
 * Cart checkout and `orders.items[]` identify catalog rows with **`itemId`**
 * (e.g. `resources/{itemId}`). Purchase hydration must expose the same shape.
 */
export function getLineItemItemId(item: unknown): string | null {
  if (!item || typeof item !== "object") return null;
  const raw = (item as { itemId?: unknown }).itemId;
  if (typeof raw === "string" && raw.trim().length > 0) return raw.trim();
  return null;
}
